export default "__VITE_ASSET__DihqMbAL__"